import API_URL from '../apiconfig';
import axios from './api';
import type { AdsAnalyticsResult, AdsEntityParam } from '../types/ads';

export async function getAdsAnalytics(
  params: AdsEntityParam,
): Promise<AdsAnalyticsResult | null> {
  try {
    const response = await axios.get(`${API_URL}/v1/ads/analytics-embed`, {
      params,
    });
    return (response.data.result as AdsAnalyticsResult) ?? null;
  } catch {
    return null;
  }
}
